import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
import { PaymentForm } from '../components/Payment/PaymentForm';
import { PaystackScript } from '../components/Payment/PaystackScript';
import { Check, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export const InnerCircle = () => {
  const [paymentStatus, setPaymentStatus] = useState<'pending' | 'success' | 'form'>('pending');
  const [reference, setReference] = useState('');
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const handleSuccess = (reference: string) => {
    setReference(reference);
    setPaymentStatus('form');
    window.scrollTo(0, 0);
  };
  const handleFormSubmit = e => {
    e.preventDefault();
    const formData = new FormData(e.target);
    fetch('https://formspree.io/f/xkgqkqqd', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json'
      }
    }).then(response => {
      if (response.ok) {
        setPaymentStatus('success');
        // Redirect to WhatsApp group
        window.location.href = 'https://chat.whatsapp.com/HqLapNaswMWGUkOjGdHd37';
      } else {
        throw new Error('Form submission failed');
      }
    }).catch(error => {
      console.error('Error:', error);
      // Handle error state
    });
  };
  if (paymentStatus === 'success') {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-1739">
        <div className="container mx-auto px-4 py-16" data-id="element-1740">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1741">
            <div className="inline-block w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6" data-id="element-1742">
              <Check size={40} className="text-gray-700" data-id="element-1743" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-1744">
              Welcome to The Networking Salon Inner Circle!
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-1745">
              Thank you for joining our community. Your registration was
              successful.
            </p>
            <p className="text-gray-600 mb-12" data-id="element-1746">
              We're redirecting you to our WhatsApp community...
            </p>
          </div>
        </div>
      </div>;
  }
  if (paymentStatus === 'form') {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-1747">
        <div className="container mx-auto px-4 py-16" data-id="element-1748">
          <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-1749">
            <div className="inline-block w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6" data-id="element-1750">
              <Check size={40} className="text-gray-700" data-id="element-1751" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-1752">
              Payment Successful!
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-1753">
              Please complete your registration to join The Networking Salon
              Inner Circle.
            </p>
            <p className="text-gray-600 mb-8" data-id="element-1754">
              Reference ID: <span className="font-medium" data-id="element-1755">{reference}</span>
            </p>
          </div>
          <div className="max-w-2xl mx-auto border-2 border-gray-300 rounded-lg p-8" data-id="element-1756">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center" data-id="element-1757">
              Complete Your Registration
            </h2>
            <form onSubmit={handleFormSubmit} className="space-y-6" data-id="element-1758">
              <input type="hidden" name="payment_reference" value={reference} data-id="element-1759" />
              <div data-id="element-1760">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-1761">
                  Full Name <span className="text-gray-500" data-id="element-1762">(required)</span>
                </label>
                <input type="text" name="name" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-1763" />
              </div>
              <div data-id="element-1764">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-1765">
                  Email <span className="text-gray-500" data-id="element-1766">(required)</span>
                </label>
                <input type="email" name="email" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-1767" />
              </div>
              <div data-id="element-1768">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-1769">
                  Phone Number <span className="text-gray-500" data-id="element-1770">(required)</span>
                </label>
                <input type="tel" name="phone" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-1771" />
              </div>
              <div data-id="element-1772">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-1773">
                  What do you do?{' '}
                  <span className="text-gray-500" data-id="element-1774">(required)</span>
                </label>
                <textarea name="occupation" required rows={3} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-1775" />
              </div>
              <div data-id="element-1776">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-1777">
                  What are you looking to gain from the Inner Circle?{' '}
                  <span className="text-gray-500" data-id="element-1778">(required)</span>
                </label>
                <textarea name="goals" required rows={3} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-1779" />
              </div>
              <div data-id="element-1780">
                <Button type="submit" className="w-full" data-id="element-1781">
                  Complete Registration
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>;
  }
  return <div className="pt-20 bg-white" data-id="element-1782">
      <PaystackScript data-id="element-1783" />
      {/* Hero Section */}
      <section className="relative py-20 border-b border-gray-200" data-id="element-1784">
        <div className="absolute inset-0 z-0" data-id="element-1785">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bNxF5qHdCS6UJLX4hcirCA/IMG_7209.jpg" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-1786" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-1787"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-1788">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1789">
            <div className="inline-block bg-white text-gray-800 px-4 py-1 rounded-full text-sm font-bold mb-6" data-id="element-1790">
              INNER CIRCLE MEMBERSHIP
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-1791">
              Join The Inner Circle
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-1792">
              Connect with ambitious professionals, build meaningful
              relationships, and unlock new opportunities.
            </p>
            <Button className="text-lg px-8 py-4" onClick={() => {
            setShowPaymentForm(true);
            setTimeout(() => {
              const element = document.getElementById('payment-form');
              if (element) {
                element.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }, 100);
          }} data-id="element-1793">
              Join Today for ₦20,000 (Founder's Offer)
            </Button>
          </div>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-1794">
        <div className="container mx-auto px-4" data-id="element-1795">
          <div className="max-w-3xl mx-auto" data-id="element-1796">
            <div className="border-2 border-gray-300 rounded-lg p-8 mb-12" data-id="element-1797">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center" data-id="element-1798">
                🌍 What the Inner Circle Is About
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-1799">
                The Inner Circle is the core community of The Networking Salon —
                a space for intentional people who want to grow, collaborate,
                and connect with purpose.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-1800">
                It's where ideas are refined, opportunities are shared, and
                relationships evolve into partnerships. Members of the Inner
                Circle gain access to curated experiences that help them learn,
                lead, and thrive within a trusted network of business leaders,
                coaches, and creators.
              </p>
              <p className="text-gray-700 mb-8" data-id="element-1801">
                This is a community for action-takers — those who believe in
                learning through collaboration, growing through mentorship, and
                building through shared value.
              </p>
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-1802">
                🔑 How to Gain Access
              </h3>
              <div className="mb-6" data-id="element-1803">
                <p className="font-bold text-gray-800" data-id="element-1804">
                  Through Direct Membership Enrollment
                </p>
                <p className="text-gray-700" data-id="element-1805">
                  Join by registering directly as an Inner Circle Member.
                </p>
                <div className="bg-gray-100 p-4 rounded-lg my-4 text-center" data-id="element-1806">
                  <p className="font-bold text-gray-800" data-id="element-1807">
                    Membership Fee: ₦50,000 per year
                  </p>
                  <p className="text-gray-700 italic" data-id="element-1808">
                    (Currently discounted to ₦20,000)
                  </p>
                </div>
                <p className="text-gray-700 mb-2" data-id="element-1809">
                  Once enrolled, you'll gain access to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-1 mb-4" data-id="element-1810">
                  <li data-id="element-1811">Curated masterclasses and peer masterminds</li>
                  <li data-id="element-1812">Mentorship and strategy sessions</li>
                  <li data-id="element-1813">Growth tools, templates, and learning resources</li>
                  <li data-id="element-1814">
                    Networking with business leaders, coaches, and fellow
                    builders
                  </li>
                  <li data-id="element-1815">
                    The private digital community — your home for collaboration
                    and opportunity
                  </li>
                </ul>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-1816">
                ✳️ Who the Inner Circle Is For
              </h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-1817">
                <li data-id="element-1818">
                  Entrepreneurs, professionals, and creators ready to grow
                  intentionally
                </li>
                <li data-id="element-1819">
                  Those seeking meaningful collaboration rather than
                  surface-level networking
                </li>
                <li data-id="element-1820">
                  Individuals who value mentorship, shared learning, and mutual
                  support
                </li>
                <li data-id="element-1821">
                  People who want to connect with a network of leaders and
                  builders across industries
                </li>
              </ul>
              <p className="text-gray-700 font-medium text-center mt-8" data-id="element-1822">
                The Inner Circle is where energy turns into execution. It's
                where you stop networking for attention and start connecting for
                impact.
              </p>
              <div className="text-center mt-6" data-id="element-1823">
                <p className="text-gray-800 font-bold" data-id="element-1824">
                  Join the Inner Circle — and step into a community that helps
                  you rise, build, and belong.
                </p>
              </div>
            </div>
            {showPaymentForm && <div id="payment-form" className="border-2 border-gray-300 rounded-lg p-8" data-id="element-1825">
                <PaymentForm onSuccess={handleSuccess} data-id="element-1826" />
              </div>}
          </div>
        </div>
      </section>
    </div>;
};